"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Upgrade = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "url(#a)",
        d: "M22.542 12.295a5.838 5.838 0 0 0-3.566.76c.05-.272.058-.566.083-.828a3.127 3.127 0 0 0 2.893-1.568c.725-1.323.44-3.161-.711-4.576a.5.5 0 0 0-.556-.155 4.041 4.041 0 0 0-2.525 2.785 6.548 6.548 0 0 0-.427-.65c2.635-2.054.876-6.331-2.1-7.043a.5.5 0 0 0-.568.237c-1.25 2.226-.172 5.587 1.592 7.043 2.8 3.142 1.16 8.034-2.784 9.323-4.043 1.61-8.856-2.567-7.81-6.756a5.64 5.64 0 0 1 1.282-2.57c1.763-1.456 2.838-4.815 1.591-7.041a.5.5 0 0 0-.57-.238 4.728 4.728 0 0 0-3.36 3.78 3.448 3.448 0 0 0 1.26 3.262c-.156.21-.3.428-.429.654a4.037 4.037 0 0 0-2.523-2.787.5.5 0 0 0-.556.156c-1.15 1.415-1.437 3.253-.712 4.576a3.126 3.126 0 0 0 2.894 1.568c.025.26.029.55.08.812a6.067 6.067 0 0 0-3.563-.745.5.5 0 0 0-.456.488c-.035 1.833.882 3.466 2.283 4.064a3.091 3.091 0 0 0 3.226-.55c.155.197.324.383.505.556a5.121 5.121 0 0 0-3.2 1.703.5.5 0 0 0 .074.793c.25.224 3.244 1.793 4.75 1.178-.115.47-.383 1.42.36 1.47a.5.5 0 0 0 .5-.5 2.5 2.5 0 0 1 5 0 .5.5 0 0 0 1 0c-.026-1.194-.484-.92.76-.841 1.69 0 3.599-1.155 3.849-1.31a.504.504 0 0 0 .072-.792l-.75-.69a4.57 4.57 0 0 0-2.445-1.014 7.04 7.04 0 0 0 .33-.343c.066-.076.119-.143.175-.212a3.091 3.091 0 0 0 3.226.55c1.4-.6 2.319-2.23 2.283-4.064a.5.5 0 0 0-.457-.486Z"
      }
    ),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "a", x1: -3.5, x2: 47, y1: 21.996, y2: 21.996, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#0BDAC9" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#7366FF" })))
  );
};
export default Upgrade;
